<template lang="pug">
  .v-range
    .v-range__label {{ label }}
    vue-slider(
      :min="min"
      :max="max"
      :speed="0"
      tooltip="active"
      :process-style="processStyle"
      :value="value"
      @change="onChange")
</template>

<script>
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
  name: 'VRange',

  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    label: String,
    value: Number
  },

  components: {
    VueSlider
  },

  data: () => ({
    processStyle: {
      background: '#1DA643'
    }
  }),

  methods: {
    onChange (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss">
  .v-range {
    &:not(:last-child) {
      margin-bottom: 10px;
    }

    &__label {
      font-size: 1.5rem;
      margin-bottom: 5px;
    }
  }
</style>
